import React from 'react';

export const hydroStatsComponent = (pModule: string, stats: any) => {
  return (
    pModule === 'hydro' && (
      <div>
        <span style={{ fontSize: 'small', fontWeight: 'bolder' }}>
          Statistiques :
        </span>
        <br />
        {stats.indicator !== 'Infinity' ? (
          <span style={{ fontSize: 'smaller' }}>
            Nb de débouchage : {stats.indicator} / Kml (
            {stats.countIndicator + ' / ' + stats.lengthIndicator / 1000})
          </span>
        ) : (
          <span style={{ fontSize: 'smaller', color: 'red' }}>
            Manque de données pour calculer le Nb de débouchage !
          </span>
        )}
        <br />
        <span style={{ fontSize: 'smaller' }}>
          Nb de points noirs : {stats.blackPoint}
        </span>
      </div>
    )
  );
};
